import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Heading,
  Text,
  Spinner,
  useToast,
} from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { Link } from 'react-router-dom';
import { BASE_URL } from '../../Globalapi/Globalapi';

const Webpannel = () => {
  const [loginDetails, setLoginDetails] = useState(null);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch login details from the API
    axios.get(`${BASE_URL}/admin/website/website_details.php`)
      .then(response => {
        const data = response.data.data[0];
        setLoginDetails({
          websiteLink: data.website_link,
          username: data.username,
          password: data.password
        });
      })
      .catch(error => {
        console.error('Error fetching login details:', error);
      });
  }, []);

  // Copy the text to clipboard and show a message
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast({
        title: 'Copied to clipboard',
        description: text,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };

  return (
    <Box position="relative" minHeight="100vh" >

<div className="teacher-list-container">
        <div className="header">
          <h1 fontSize="20px">Webpannel</h1>
          <div className="action-buttons">
     
           
          </div>
        </div>
        <div className="breadcrumb">
        <Link to="/admin" style={{ textDecoration: 'none', color: 'inherit' }}>
        <span>Dashboard</span>
    </Link>  / <span>Webpannel</span> 
        </div>
{/* 
      <Button 
        // colorScheme="gray" 

        backgroundColor="white"
        boxShadow="md"
        fontSize="11px"

        color="#515B73"

        position="absolute" 
        top="10px" 
        left="30px" 
        onClick={() => navigate(-1)}
      >
          <ArrowBackIcon />
          </Button> */}

      <Box maxWidth="400px" mx="auto" borderWidth="1px" marginTop={20} borderRadius="lg" p={5}>
        <Heading as="h1" size="lg" mb={4}>Webpannel</Heading>
        {loginDetails ? (
          <>
            <Button
              colorScheme="blue"
              onClick={() => window.open(loginDetails.websiteLink, '_blank')}
              mb={4}
              width="100%"
            >
              Go to Admin Login
            </Button>

            <Box mb={4}>
              <Text fontWeight="bold">Username:</Text>
              <Text>{loginDetails.username}</Text>
              <Button
                onClick={() => copyToClipboard(loginDetails.username)}
                colorScheme="teal"
                size="sm"
                mt={2}
              >
                Copy Username
              </Button>
            </Box>
            <Box>
              <Text fontWeight="bold">Password:</Text>
              <Text>{loginDetails.password}</Text>
              <Button
                onClick={() => copyToClipboard(loginDetails.password)}
                colorScheme="teal"
                size="sm"
                mt={2}
              >
                Copy Password
              </Button>
            </Box>
          </>
        ) : (
          <Spinner size="lg" />
        )}
      </Box>
      </div>
    </Box>
  
  );
};

export default Webpannel;
